// @flow strict

export { default as ReadMore } from './ReadMore';
export { default as ReadMoreFadeOut } from './ReadMoreFadeOut';
export { default as Abbreviate } from './Abbreviate';
export { default as AbbreviateWithMore } from './AbbreviateWithMore';
export { default as AutoResizer } from './AutoResizer';
export { escapeHtml as EscapeHtml, unescapeHtml } from '@ta/common.text-html';
export { default as DirectionalText } from './DirectionalText';
export { default as DottedUnderline } from './DottedUnderline';

export type { ClickTarget } from './ReadMoreBase';
